import { Helmet } from 'react-helmet'
import CustomRangeSlider from './CustomRangeSlider'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Custom Range Slider</title>
    </Helmet>
    <CustomRangeSlider />
  </>
)
export default Wrapper
